import * as yup from 'yup';

export const GroupImportValidationSchema = yup.object().shape({
    importType: yup.string().required('Import type is required').nullable(),
    file: yup.mixed().test(
        'fileIsRequired',
        'File is required',
        function (item) {
            return (this.parent.file !== undefined && this.parent.file !== null && this.parent.file.size > 0)
        }
    ),
    scorecards: yup
        .array()
        .min(1, "Please select at least one scorecard")
        .nullable()
});


